import React from "react";
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import SearchGlobal from "../../../../shared/SearchGlobal";
import {
  Box,
  IconButton,
  Slide,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import { SIDEBAR_STYLES, SIDEBAR_VARIANTS } from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import { getUserTimeZone } from "../../../../services/config";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Link from "@mui/material/Link";
import authServices from "../../../../services/auth-services";
import { useAppMutation } from "../../../../services";
import parentServices from "../../../../services/parent-services";
import { useDispatch, useSelector } from "react-redux";
import { onSaveProfile, onSuccessLogin } from "../../../../redux/actions";
import { Link as RouterLink } from "react-router-dom";

const Header = () => {
  const { userProfile } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const [dropdownSearchVisibility, setDropdownSearchVisibility] =
    React.useState(false);
  const { headerTheme } = useJumboHeaderTheme();

  const showDropdownSearch = useMediaQuery("(max-width:575px)");
  const isParent = authServices.isParent();

    const paymentFailed = Boolean(
        userProfile?.stripeLastPayment?.failure?.message
    );

  const {
    mutate: loadProfile,
    isSuccess,
    data: profile,
    isError,
  } = useAppMutation(parentServices.loadProfile);

  React.useEffect(() => {
    if (isSuccess) {
      dispatch(onSaveProfile(profile));
    }
  }, [isError, isSuccess]);

  React.useEffect(() => {
      if(isParent){
          loadProfile();
      }
  }, [isParent]);


  return (
    <React.Fragment>
      {(sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ||
        sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY ||
        (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT &&
          !sidebarOptions.open)) && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          sx={{
            ml:
              sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
                ? -2
                : 0,
            mr: 3,
          }}
          onClick={() => setSidebarOptions({ open: !sidebarOptions.open })}
        >
          {sidebarOptions?.open ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
      )}
      {sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <Logo sx={{ mr: 3 }} mode={headerTheme.type ?? "light"} />
      )}
      {showDropdownSearch && (
        <Slide in={dropdownSearchVisibility}>
          <Div
            sx={{
              zIndex: 5,
              left: 0,
              right: 0,
              position: "absolute",
              height: "100%",
            }}
          >
            <SearchGlobal
              sx={{
                maxWidth: "none",
                height: "100%",
                display: "flex",

                "& .MuiInputBase-root": {
                  flex: 1,
                  borderRadius: 0,
                  background: (theme) => theme.palette.background.default,
                },
                "& .MuiInputBase-input": {
                  pr: 6,
                },
              }}
            />
            <IconButton
              sx={{
                position: "absolute",
                right: 15,
                top: "50%",
                color: "inherit",
                transform: "translateY(-50%)",
              }}
              onClick={() => setDropdownSearchVisibility(false)}
            >
              <CloseIcon />
            </IconButton>
          </Div>
        </Slide>
      )}
      {!showDropdownSearch && (
        <SearchGlobal
          sx={{
            maxWidth: { xs: 240, md: 320 },
          }}
        />
      )}
        {isParent && userProfile?.stripeLastPayment?.failure?.message && (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 1.5,
            py: 0.5,
            borderRadius: 2,
            bgcolor: "#FDECEA", // light red background
            border: "1px solid #F5C2C7", // subtle border
            maxWidth: { xs: "100%", sm: 600 },
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 18, color: "#F9583C" }} />
          <Typography
            variant="body2"
            sx={{ color: "#F9583C", fontWeight: 600 }}
          >
            Dernier prélèvement échoué. Pour poursuivre vos cours,
          </Typography>

          {/* Only this is a link + underline */}
            <Link
                component={RouterLink}
                to="/dashboard/subscription/subscribed"
                underline="always"
                sx={{
                    color: "#1D6ADE",
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                }}
            >
                régularisez ici
                <ArrowForwardIosRoundedIcon sx={{ fontSize: 14, ml: 0.5 }} />
            </Link>
        </Box>
      )}

      <Stack
        direction="row"
        alignItems="center"
        spacing={1.25}
        sx={{ ml: "auto" }}
      >
        {showDropdownSearch && (
          <JumboIconButton
            elevation={25}
            onClick={() => setDropdownSearchVisibility(true)}
          >
            <SearchIcon fontSize={"small"} />
          </JumboIconButton>
        )}
        {/**<MessagesDropdown/>**/}
        {/**<NotificationsDropdown/>**/}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
            py: 0.5,
            backgroundColor: (theme) => theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: (theme) => theme.shadows[2],
            border: `1px solid ${(theme) => theme.palette.divider}`,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "#1d6ade", fontWeight: "bold" }}
          >
            {getUserTimeZone()}
          </Typography>
        </Box>
        <AuthUserDropdown />
      </Stack>
    </React.Fragment>
  );
};

export default Header;
